export interface ReportListTableHeader {
  field?: string;
  header?: string;
}
export const reportListTableHeaders: ReportListTableHeader[] = [
  { field: 'name', header: 'Reports' },
  { field: 'description', header: 'Description' }
];
